import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import Navbar from "./Navbar";
import Footer from "./header and footer/Footer";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChalkboardUser,
  faPlay,
  faBookOpen,
  faGraduationCap,
  faSpinner,
  faTrophy,
  faRotateRight,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";

function Learnings() {
  const userId = localStorage.getItem("id");
  const [courses, setCourses] = useState([]);
  const [assessmentMap, setAssessmentMap] = useState({}); // { courseId: maxMarks }
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        // Fetch enrolled courses
        const res = await axios.get(`${API_BASE_URL}/api/learning/${userId}`);
        const enrolledCourses = Array.isArray(res.data) ? res.data : [];
        setCourses(enrolledCourses);

        // Fetch assessment performance for user
        const perfRes = await fetch(`${API_BASE_URL}/api/assessments/perfomance/${userId}`);
        const perfData = await perfRes.json();

        // Build map: courseId -> best marks
        const map = {};
        if (Array.isArray(perfData)) {
          perfData.forEach((a) => {
            const cid = a.course_id;
            if (cid !== undefined) {
              map[cid] = Math.max(map[cid] || 0, a.marks || 0);
            }
          });
        }
        setAssessmentMap(map);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching enrolled learnings:", err);
        setLoading(false);
      }
    }
    fetchData();
  }, [userId]);

  const isCompleted = (courseId) => (assessmentMap[courseId] || 0) >= 90;

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#f8fafc" }}>
      <Navbar page={"learnings"} />

      {/* Header Banner */}
      <div className="page-banner" style={{ padding: "56px 6% 48px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(255,255,255,0.1)", padding: "6px 16px", borderRadius: "20px", fontSize: "0.85rem", marginBottom: "16px" }}>
          <FontAwesomeIcon icon={faGraduationCap} style={{ color: "#a5b4fc" }} />
          Student Dashboard
        </div>
        <h1>My Enrolled Courses</h1>
        <p>Pick up right where you left off and continue your learning journey.</p>
      </div>

      {/* Dashboard Main Container */}
      <div style={{ flex: 1, padding: "50px 6% 80px", maxWidth: "1280px", margin: "0 auto", width: "100%" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "#64748b" }}>
            <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "2.2rem", color: "#4f46e5", marginBottom: "14px" }} />
            <p>Loading your enrolled courses...</p>
          </div>
        ) : courses.length === 0 ? (
          <div style={{ textAlign: "center", padding: "70px 0", color: "#64748b", background: "#fff", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.03)" }}>
            <FontAwesomeIcon icon={faBookOpen} style={{ fontSize: "3rem", color: "#cbd5e1", marginBottom: "16px" }} />
            <h2 style={{ color: "#0f172a", marginBottom: "10px" }}>No Enrolled Courses Yet</h2>
            <p style={{ maxWidth: "480px", margin: "0 auto 24px", color: "#64748b" }}>
              Explore our accredited catalog to enroll in top-rated courses and expand your professional skill set.
            </p>
            <button
              onClick={() => navigate("/courses")}
              style={{
                background: "linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)",
                color: "#fff",
                border: "none",
                padding: "12px 28px",
                borderRadius: "10px",
                fontWeight: 700,
                fontSize: "0.95rem",
                cursor: "pointer",
                boxShadow: "0 4px 14px rgba(79,70,229,0.3)"
              }}
            >
              Explore Course Catalog
            </button>
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
              gap: "28px"
            }}
          >
            {courses.map((course) => {
              const cId = course.course_id || course.id;
              const title = course.courseName || course.course_name || "Course Module";
              const completed = isCompleted(cId);

              return (
                <div
                  key={cId}
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    overflow: "hidden",
                    border: completed ? "1.5px solid #10b981" : "1px solid #e2e8f0",
                    boxShadow: completed
                      ? "0 4px 18px -4px rgba(16,185,129,0.2)"
                      : "0 4px 6px -1px rgba(0,0,0,0.04)",
                    display: "flex",
                    flexDirection: "column",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    position: "relative"
                  }}
                  className="course-card"
                >
                  {/* Completion ribbon */}
                  {completed && (
                    <div
                      style={{
                        position: "absolute",
                        top: "14px",
                        right: "14px",
                        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "5px 12px",
                        fontSize: "0.75rem",
                        fontWeight: 800,
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        boxShadow: "0 4px 12px rgba(16,185,129,0.35)",
                        zIndex: 2,
                        letterSpacing: "0.02em"
                      }}
                    >
                      <FontAwesomeIcon icon={faTrophy} />
                      COMPLETED
                    </div>
                  )}

                  <div style={{ width: "100%", height: "180px", overflow: "hidden" }}>
                    <img
                      src={
                        course.photo ||
                        course.p_link ||
                        "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&auto=format&fit=crop&q=60"
                      }
                      alt={title}
                      style={{ width: "100%", height: "180px", objectFit: "cover", display: "block" }}
                      onError={(e) => {
                        e.target.src =
                          "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&auto=format&fit=crop&q=60";
                      }}
                    />
                  </div>

                  <div style={{ padding: "20px", flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <div>
                      <h3 style={{ fontSize: "1.1rem", fontWeight: 800, color: "#0f172a", marginBottom: "8px", lineHeight: "1.3" }}>
                        {title}
                      </h3>
                      <p style={{ color: "#64748b", fontSize: "0.86rem", marginBottom: "6px" }}>
                        <FontAwesomeIcon icon={faChalkboardUser} style={{ marginRight: "6px", color: "#4f46e5" }} />
                        by {course.instructor || course.tutor || "Academic Specialist"}
                      </p>
                      {completed && (
                        <p style={{ color: "#10b981", fontSize: "0.82rem", fontWeight: 600, marginBottom: "6px", display: "flex", alignItems: "center", gap: "5px" }}>
                          <FontAwesomeIcon icon={faCheckCircle} />
                          Score: {assessmentMap[cId]}% — Course Completed!
                        </p>
                      )}
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "14px" }}>
                      <button
                        onClick={() => navigate(`/course/${cId}`)}
                        style={{
                          width: "100%",
                          background: "linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)",
                          color: "#fff",
                          border: "none",
                          padding: "11px",
                          borderRadius: "10px",
                          fontWeight: 700,
                          fontSize: "0.9rem",
                          cursor: "pointer",
                          boxShadow: "0 4px 12px rgba(79,70,229,0.25)",
                          transition: "all 0.25s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "7px"
                        }}
                      >
                        <FontAwesomeIcon icon={faPlay} />
                        {completed ? "Watch Again" : "Continue Learning"}
                      </button>

                      {/* Always show Retake Quiz if completed */}
                      {completed && (
                        <button
                          onClick={() => navigate(`/assessment/${cId}`)}
                          style={{
                            width: "100%",
                            background: "rgba(16,185,129,0.08)",
                            color: "#059669",
                            border: "1.5px solid #10b981",
                            padding: "9px",
                            borderRadius: "10px",
                            fontWeight: 700,
                            fontSize: "0.88rem",
                            cursor: "pointer",
                            transition: "all 0.25s ease",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "7px"
                          }}
                        >
                          <FontAwesomeIcon icon={faRotateRight} />
                          Retake Quiz
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default Learnings;